import { ApiClient } from '../../Shared/interfaces/ApiClient';
import { InventoryApiResponse } from '../interfaces/InventoryDashboardInterfaces';
import { UNIFIED_SLOTS_ENDPOINT, CHECK_INVENTORY_EXIST_ENDPOINT, SLOT_TYPES, SlotTypeValue } from '../constants/endpoints';

const getSlotData =
  (slotType: SlotTypeValue) =>
  (api: ApiClient, artEventId: string | null | undefined): Promise<InventoryApiResponse | null> => {
    const params = new URLSearchParams({ artEventId: artEventId || '', slotType });
    return api.get<InventoryApiResponse>(`${UNIFIED_SLOTS_ENDPOINT}?${params}`);
  };

export const getGatewayData = getSlotData(SLOT_TYPES.GATEWAY);
export const getStarPackageData = getSlotData(SLOT_TYPES.STAR_PACKAGE);
export const getMThankyouData = getSlotData(SLOT_TYPES.MTHANKYOU);
export const getWPClass1Data = getSlotData(SLOT_TYPES.WP_CLASS1);
export const getILMClass1Data = getSlotData(SLOT_TYPES.ILM_CLASS1);
export const getMContextualClass1CpmData = getSlotData(SLOT_TYPES.MCONTEXTUAL_CLASS1_CPM);
export const getDContextualClass1CpmData = getSlotData(SLOT_TYPES.DCONTEXTUAL_CLASS1_CPM);
export const getPPPClass1Data = getSlotData(SLOT_TYPES.PPP_CLASS1);
export const getWD2TargetedClass1Data = getSlotData(SLOT_TYPES.WD2_TARGETED_CLASS1);
export const getROSDSPUnguaranteedData = getSlotData(SLOT_TYPES.ROS_DSP_UNGUARANTEED);

export const checkInventoryExist = async (api: ApiClient, artEventId: string) => {
  const params = new URLSearchParams({ artEventId, checkInventoryExist: 'true' });
  return api.get(`${CHECK_INVENTORY_EXIST_ENDPOINT}?${params}`);
};
